module.exports = __webpack_public_path__ + "img/美容師建議@2x.4de23eec.png";